<template>
  <c-row>
    <c-col col="12">
      <loader v-show="loading" />
      <c-card>
        <c-card-body>
          <div class="form-group form-row">
            <label class="col-form-label col-md-2">Filter Tanggal</label>
            <div class="col-md-3">
              <datetime
                class="date-control"
                v-model="filter.date"
                @input="changeFilterDate"
              />
            </div>
          </div>
          <div style="overflow: auto">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Tanggal</th>
                  <th>Penjelasan Transaksi</th>
                  <th>Keterangan</th>
                  <th>Debit</th>
                  <th>Kredit</th>
                  <th>Jumlah Setor</th>
                  <th>Setor Tanggal</th>
                  <th>Via</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, k) in cashHistory.data" :key="k">
                  <td align="center" width="35">
                    <table-number
                      :page="paginate.page"
                      :size="paginate.per_page"
                      :index="k"
                    />
                  </td>
                  <td>{{ d.date | dateFormat }}</td>
                  <td>{{ d.description }}</td>
                  <td>{{ d.notes }}</td>
                  <td class="right">{{ d.debit | thousandSeparator }}</td>
                  <td class="right">{{ d.credit | thousandSeparator }}</td>
                  <td class="right" v-if="d.first_data" :rowspan="d.row_span">
                    {{ d.deposit_amount | thousandSeparator }}
                  </td>
                  <td class="right" v-if="d.first_data" :rowspan="d.row_span">
                    {{ d.deposit_date | dateFormat }}
                  </td>
                  <td class="right" v-if="d.first_data" :rowspan="d.row_span">
                    {{ d.bank_name }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-card-body>
        <c-card-footer>
          <export-excel
            class="float-left"
            :url="`/api/v1/export/excel/installation-service?date=${this.filter.date}`"
          />
          <CPagination
            align="end"
            :active-page.sync="currentPage"
            :pages="Math.ceil(paginate.total / paginate.per_page)"
            responsive
          />
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
import TableNumber from "../../components/TableNumber";
import ExportExcel from '../../components/ExportExcel.vue';
import Loader from '../../components/Loader.vue';
export default {
  components: {
    TableNumber,
    ExportExcel,
    Loader,
  },
  data () {
    return {
      loading: true,
      cashHistory: {},
      paginate: {},
      currentPage: 1,
      errors: [],
      filter: {},
    };
  },
  created () {
    this.histories(1);
  },
  methods: {
    changeFilterDate () {
      this.histories(1);
    },
    histories (page) {
      this.loading = true;
      const date = this.filter && this.filter.date ? this.filter.date : "";
      HTTPAUTH.get(
        `/api/v1/installation-history?size=10&date=${date}&page=${page}`
      )
        .then((res) => {
          this.cashHistory = res.data;
          this.paginate = res.data.paginate;
          this.currentPage = this.paginate.page;
          this.disableLoading();
        })
        .catch(() => {
          this.disableLoading();
        });
    },
    disableLoading () {
      setTimeout(() => {
        this.loading = false;
      }, 300);
    },
  },
  watch: {
    currentPage (pageNext) {
      this.histories(pageNext);
    },
  },
};
</script>